import { render, staticRenderFns } from "./Portfolio_Component.vue?vue&type=template&id=764c37d0&scoped=true"
import script from "./Portfolio_Component.vue?vue&type=script&lang=js"
export * from "./Portfolio_Component.vue?vue&type=script&lang=js"
import style0 from "./Portfolio_Component.vue?vue&type=style&index=0&id=764c37d0&prod&scoped=true&lang=css"
import style1 from "./Portfolio_Component.vue?vue&type=style&index=1&id=764c37d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764c37d0",
  null
  
)

export default component.exports